import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import apiClient from "../utils/apiClient";
import RecipeCard from "../components/RecipeCard";
import BackButton from "../components/BackButton"

export default function RecipeDetail() {
  const { index } = useParams();
  const [searchParams] = useSearchParams();
  const servings = searchParams.get("serve");
  const [recipe, setRecipe] = useState(null);

  useEffect(() => {
    const loadRecipe = async () => {
      //const params = new URLSearchParams(window.location.search);
      //const servings = params.get("serve");
      try {
        if (servings) {
          const res = await apiClient.post("/recipes/scale", { recipeId: index, servings });
          setRecipe(res.data.recipe);
        } else {
          const res = await apiClient.get(`/recipes/recipe/${index}`);
          setRecipe(res.data);
        }
      } catch (err){
        console.log("Failed to load recipe");
        return("Something went wrong :/");
      }
    };
  
    loadRecipe();
  }, [index, servings]);

  return (
    <div className="max-w-4xl mx-auto px-4 mt-8 space-y-6">
      <BackButton/>

      {recipe ? (
        <RecipeCard recipe={recipe} />
      ) : (
        <p className="text-gray-500">Loading recipe...</p>
      )}
    </div>
  );
}
